import "./elements/ambience-player.js";
import "./elements/card-container.js";
import "./elements/click-toggle.js";
import "./elements/credits-graph.js";
import "./elements/details-list.js";
import "./elements/dotted-border.js";
import "./elements/image-gallery.js";
import "./elements/info-box.js";
import "./elements/info-panel.js";
import "./elements/list-selector.js";
import "./elements/local-time.js";
import "./elements/logo-trail.js";
import "./elements/morph-container.js";
import "./elements/particle-icon.js";
import "./elements/particle-simulation";
import "./elements/pip-container.js";
import "./elements/radial-menu.js";
import "./elements/scroll-list.js";
import "./elements/studio-film.js";
import "./elements/sub-nav.js";
import "./elements/tooltip-container.js";
import "./elements/video-player.js";

function shouldNotIntercept(navigationEvent) {
  return (
    !navigationEvent.canIntercept ||
    navigationEvent.hashChange ||
    navigationEvent.downloadRequest ||
    navigationEvent.formData
  );
}

async function fetchPage(url, signal, { target = "layout" } = {}) {
  const response = await fetch(url, {
    headers: { "X-Target": target },
    cache: "no-store",
    signal,
  });
  if (!response.ok) throw new Error(response.status);
  const html = await response.text();
  const layout = response.headers.get("X-Layout");
  const title = response.headers.get("X-Title");
  return { html, layout, title };
}

function updateTmpl(layout) {
  const root = document.documentElement;
  root.className = root.className.replace(/tmpl-\w+/g, "").trim();
  root.classList.add(`tmpl-${layout}`);
}

function updateNav(url) {
  for (const el of document.querySelectorAll("nav ul a:not(sub-nav a)")) {
    if (el.origin !== location.origin) continue;
    const active = el.pathname === url.pathname;
    el.classList.toggle("active", active);
  }
}

if (window.navigation) {
  navigation.addEventListener("navigate", (navigateEvent) => {
    if (shouldNotIntercept(navigateEvent)) return;

    const lastUrl = new URL(window.location);
    const nextUrl = new URL(navigateEvent.destination.url);

    if (lastUrl.pathname === "/work" && nextUrl.pathname === "/work") {
      navigateEvent.intercept({
        scroll: "manual",
        async handler() {
          const { html, title } = await fetchPage(nextUrl, navigateEvent.signal, {
            target: "partial",
          });

          const container = document.querySelector(".Work-items");

          container.innerHTML = html;
          window.scrollTo(0, 0);
          container.animate(
            [
              { opacity: 0, transform: "translateY(8px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: 300, easing: "ease" }, // TODO: Define easing
          );

          document.title = title;
        },
      });
      return;
    }

    navigateEvent.intercept({
      scroll: "manual", // TODO: Use navigateEvent.navigateType for scroll restoration on back
      async handler() {
        document.getElementById("burger")?.toggle(false);
        document.getElementById("contact")?.toggle(false);

        const { html, layout, title } = await fetchPage(nextUrl, navigateEvent.signal);
        const shift = nextUrl.pathname === "/" ? 0 : 8;

        const container = document.querySelector("main");

        container.innerHTML = html;
        window.scrollTo(0, 0);
        container.animate(
          [
            { opacity: 0, transform: `translateY(${shift}px)` },
            { opacity: 1, transform: "translateY(0)" },
          ],
          { duration: 300, easing: "ease" }, // TODO: Define easing
        );

        updateTmpl(layout);

        if (lastUrl.pathname === "/") {
          withoutTransitions(() => {
            updateNav(nextUrl);
          });
        } else {
          updateNav(nextUrl);
        }

        document.title = title;
      },
    });
  });
}

function withoutTransitions(fn) {
  const root = document.documentElement;

  root.classList.add("no-transitions");
  fn();

  void root.offsetWidth;

  root.classList.remove("no-transitions");
}

// Clicking an email address copies it instead of opening the mail app.
// The link shows "Copied" in place for a moment, then reverts.
addEventListener("click", async (e) => {
  const link = e.target.closest?.('a[href^="mailto:"]');
  if (!link || !navigator.clipboard) return;
  e.preventDefault();

  try {
    await navigator.clipboard.writeText(decodeURIComponent(new URL(link.href).pathname));
  } catch {
    location.href = link.href;
    return;
  }

  link.setAttribute("copied", "");
  clearTimeout(link.copiedTimer);
  link.copiedTimer = setTimeout(() => link.removeAttribute("copied"), 1200);
});
